// @aiContributed-2025-10-28
import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedCampaignKeywordsStepWithI18n =
  () => import(/* webpackChunkName: 'campaign-keywords-step.async' */'./campaign-keywords-step')
    .then(({ CampaignKeywordsStepWithI18n }) => CampaignKeywordsStepWithI18n);

const DelayedCampaignKeywordsLazyRepository =
  () => import(/* webpackChunkName: 'campaign-keywords-lazy-repository.async' */'./campaign-keywords-lazy-repository')
    .then(({ CampaignKeywordsLazyRepositoryWithI18n }) => CampaignKeywordsLazyRepositoryWithI18n);

export const SearchCampaignKeywordsStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.SEARCH_CAMPAIGN_KEYWORDS,
  view: DelayedCampaignKeywordsStepWithI18n,
  repository: DelayedCampaignKeywordsLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
  viewProps: {
    isSignup: true,
  },
  repositoryProps: {
    isSignup: true,
  },
};
